import { createReducer, on } from '@ngrx/store';

import { FeatureFlag } from '../../models/feature-flag.model';
import {
    loadFeatureFlags, loadFeatureFlagsFailed, loadFeatureFlagsSuccess
} from '../actions/feature-flags.actions';

export interface FeatureFlagsState {
  featureFlags: FeatureFlag[];
  isLoading: boolean;
  error: string;
}

export const initialFeatureFlagsState: FeatureFlagsState = {
  featureFlags: [],
  isLoading: false,
  error: '',
};

export const featureFlagsReducer = createReducer(
  initialFeatureFlagsState,
  on(
    loadFeatureFlags,
    (state): FeatureFlagsState => ({
      ...state,
      isLoading: true,
    }),
  ),
  on(
    loadFeatureFlagsSuccess,
    (state, { featureFlags }): FeatureFlagsState => ({
      ...state,
      featureFlags,
      isLoading: false,
      error: '',
    }),
  ),
  on(
    loadFeatureFlagsFailed,
    (state, { error }): FeatureFlagsState => ({
      ...state,
      featureFlags: [],
      isLoading: false,
      error: error,
    }),
  ),
);
